import {
  getApiV1ThreeLetterCodePartnerAdminsPartnerBranches,
  getGetApiV1ThreeLetterCodePartnerAdminsPartnerBranchesKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsPartnerBranches200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** 3文字コード */
  threeLetterCode: string;
};

type ReturnType = {
  data: GetApiV1ThreeLetterCodePartnerAdminsPartnerBranches200;
};

type IUseGetPartnerAdminsPartnerBranches = (args: Args) => ReturnType;

/**
 * 取引店舗一覧を取得するカスタムフック（PartnerAdmin 専用エンドポイント）
 *
 * GET /api/v1/{threeLetterCode}/partner_admins/partner_branches を使用（認証必須。Bearer トークンは axiosInstance のインターセプターが自動付与）。
 * enable: false の店舗は API 側で除外済みのため、返却された一覧をそのまま使用する。
 *
 * ClientList / CreateClientForm / EditClient の3箇所で共通利用するため
 * `apps/partner-admin/src/hooks/` に共有hookとして配置する（PEN-994）。
 *
 * @param args.threeLetterCode - パートナーを識別する3文字コード
 * @returns data - 取引店舗一覧
 */
export const useGetPartnerAdminsPartnerBranches: IUseGetPartnerAdminsPartnerBranches = ({
  threeLetterCode,
}) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsPartnerBranchesKey(threeLetterCode),
    () => getApiV1ThreeLetterCodePartnerAdminsPartnerBranches(threeLetterCode),
    { suspense: true }
  );

  return { data };
};
